import type { UnknownEvent } from '@faststore/sdk'
import { sendAnalyticsEvent } from '@faststore/sdk'
import Link from 'src/components/ui/Link'

import type { CarouselInformativeItemButtonProps } from '../carousel-informative'
import { getCustomStyles } from '../utils'

interface ButtonProps {
  classSlide: string
  button?: CarouselInformativeItemButtonProps
}

const Button = ({ classSlide, button }: ButtonProps) => {
  const customStylesButton = getCustomStyles(button?.styles)

  const handleClick = () => {
    sendAnalyticsEvent<UnknownEvent>({
      name: 'select_promotion',
      params: {
        promo: button?.to,
      },
    })
  }

  if (!button) {
    return <></>
  }

  return (
    <>
      <div className={`${classSlide}-button-container`}>
        <Link as="a" href={button?.to} onClick={handleClick}>
          <button className={`${classSlide}-button`} style={customStylesButton}>
            {button?.label}
          </button>
        </Link>
      </div>
    </>
  )
}

export default Button
